import { useExpertUniversityConfiguration } from "@expert/expert-university";
import { trackFullStoryEvent } from "@expert/monitoring";
import { Button, Menu, Space } from "@mantine/core";
import { useState } from "react";

import { CaretDown, CaretUp } from "@/common-ui";
import { AmazonIcon } from "@/expert-university/components/icons/AmazonIcon";
import { ATTIcon, VerizonIcon } from "@/sales-tools/unified-sales-view/components/icons";

export function PartnerSelectionMenu() {
    const { trainingPartner, allowedPartners, setTrainingPartner } = useExpertUniversityConfiguration();

    const [menuOpen, setMenuOpen] = useState(false);

    function PartnerOption() {
        return allowedPartners.map((partner) => (
            <Menu.Item
                key={partner}
                onClick={() => {
                    setTrainingPartner(partner);
                    setMenuOpen(false);
                    trackFullStoryEvent("Expert_University_Partner_Changed", { partner });
                }}
            >
                {partner === "verizon" ? (
                    <VerizonIcon width={65} height={40} />
                ) : partner === "att" ? (
                    <ATTIcon width={60} height={30} />
                ) : partner === "amazonrouter" ? (
                    <AmazonIcon width={65} height={40} />
                ) : null}
            </Menu.Item>
        ));
    }
    return (
        <Menu
            shadow="sm"
            radius="md"
            zIndex="var(--mantine-priority-highest)"
            opened={menuOpen}
            onChange={setMenuOpen}
            closeOnClickOutside
            closeOnItemClick={false}
        >
            <Menu.Target>
                <Button
                    color="var(--mantine-color-text)"
                    data-testid="partner-selection-menu"
                    id="partner-selection-menu"
                    data-menu-open={menuOpen}
                    size="xs"
                    variant="subtle"
                >
                    {trainingPartner === "verizon" ? (
                        <VerizonIcon width={65} height={40} />
                    ) : trainingPartner === "att" ? (
                        <ATTIcon width={60} height={30} />
                    ) : trainingPartner === "amazonrouter" ? (
                        <AmazonIcon width={65} height={40} />
                    ) : null}
                    <Space w="xs" />
                    {menuOpen ? <CaretUp /> : <CaretDown />}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                <PartnerOption />
            </Menu.Dropdown>
        </Menu>
    );
}
